import {
  AwardIcon,
  CheckMark,
  ClockIcon,
  DeleteIcon,
  DownloadIcon,
  FilledPlusIcon,
  PreviousIcon,
  ResendIcon,
} from '@root/src/assets/images';
import {
  BlackDropButton,
  GreenDropButton,
  GreenDropLink,
  RedDropButton,
} from '../styles';
import Lang from '@lang/en';
import { ComponentOptionI } from '@root/src/app/designSystem/contextMenu/contextMenu';
import { HandlersI } from './actions';
import { healthCheckDownloadCertificateUrl } from '@app/definition/API';

const generateUrlForDownloadCertificate = (): string => {
  const subPath = window.location.pathname.match(/\/(\d+)$/);
  const orderId = subPath && subPath.length ? subPath[1] : '';
  return healthCheckDownloadCertificateUrl.replace('%id%', orderId);
};

export type OptionsI = {
  confirmButtonOptions: ComponentOptionI;
  markTestedButtonOptions: ComponentOptionI;
  addResultButtonOptions: ComponentOptionI;
  startTimerButtonOptions: ComponentOptionI;
  resendCertificateButtonOptions: ComponentOptionI;
  previousStageButton: ComponentOptionI;
  generateCertificateButtonOptions: ComponentOptionI;
  editResultButtonOptions: ComponentOptionI;
  deleteOrderButtonOptions: ComponentOptionI;
  generateCertificatePCR: ComponentOptionI;
  generateCertificateAntigen: ComponentOptionI;
  downloadCertificateButtonOptions: ComponentOptionI;
};

const getOptionButtons = (handlers: HandlersI): OptionsI => {
  const confirmButtonOptions = {
    'data-testid': 'healthcheck-order-confirm-order-button',
    component: GreenDropButton,
    onClick: handlers.handleOrderConfirmed,
    icon: <CheckMark />,
    label: Lang.healthCheckConfirmOrderText,
  };

  const markTestedButtonOptions = {
    'data-testid': 'healthcheck-order-mark-as-tested-button',
    component: GreenDropButton,
    onClick: handlers.handleTestPerformed,
    icon: <CheckMark />,
    label: Lang.healthCheckMarkAsTestedOrderText,
  };

  const addResultButtonOptions = {
    'data-testid': 'healthcheck-order-add-results-button',
    component: BlackDropButton,
    onClick: handlers.handleAddResultsOpen,
    icon: <FilledPlusIcon />,
    label: Lang.healthCheckAddResultsText,
  };

  const startTimerButtonOptions = {
    'data-testid': 'healthcheck-order-start-timer-button',
    component: GreenDropButton,
    onClick: handlers.handleTestPerformed,
    icon: <ClockIcon />,
    label: Lang.healthCheckStartTimerText,
  };

  const resendCertificateButtonOptions = {
    'data-testid': 'healthcheck-order-resend-certificate-button',
    component: GreenDropButton,
    onClick: handlers.handleResendCertificate,
    icon: <ResendIcon />,
    label: Lang.healthCheckResendCertificateText,
  };

  const Link = () => {
    return (
      <GreenDropLink href={generateUrlForDownloadCertificate()}>
        {<DownloadIcon />}
        {Lang.healthCheckDownloadCertificateText}
      </GreenDropLink>
    );
  };

  const downloadCertificateButtonOptions = {
    'data-testid': 'healthcheck-order-download-certificate-button',
    component: Link,
    icon: <DownloadIcon />,
    label: Lang.healthCheckDownloadCertificateText,
  };

  const editResultButtonOptions = {
    'data-testid': 'healthcheck-order-edit-results-button',
    component: BlackDropButton,
    onClick: handlers.handleAddResultsOpen,
    icon: <FilledPlusIcon />,
    label: Lang.healthCheckEditResultsText,
  };

  const deleteOrderButtonOptions = {
    'data-testid': 'healthcheck-order-delete-button',
    label: Lang.deleteText,
    component: RedDropButton,
    type: 'danger',
    icon: <DeleteIcon />,
    onClick: handlers.handleDeleteOrderOpen,
  };

  const generateCertificateButtonOptions = {
    'data-testid': 'healthcheck-order-generate-certificate-button',
    component: BlackDropButton,
    onClick: handlers.handleGenerateCertificate,
    icon: <AwardIcon />,
    label: Lang.healthCheckGenerateCertificateText,
  };

  const previousStageButton = {
    'data-testid': 'healthcheck-order-previous-stage-button',
    component: BlackDropButton,
    onClick: handlers.handlePreviousStageOrderOpen,
    icon: <PreviousIcon />,
    label: Lang.healthCheckPreviousStageText,
  };

  const generateCertificatePCR = {
    'data-testid': 'healthcheck-order-menu-generate-pcr-button',
    component: BlackDropButton,
    onClick: () => {
      //nothing
    },
    icon: <AwardIcon />,
    label: Lang.healthCheckGeneratePCRCertificateLabel,
  };

  const generateCertificateAntigen = {
    'data-testid': 'healthcheck-order-menu-generate-antigen-button',
    component: BlackDropButton,
    onClick: () => {
      //nothing
    },
    icon: <AwardIcon />,
    label: Lang.healthCheckGenerateAntigenCertificateLabel,
  };

  return {
    confirmButtonOptions,
    markTestedButtonOptions,
    addResultButtonOptions,
    startTimerButtonOptions,
    resendCertificateButtonOptions,
    previousStageButton,
    generateCertificateButtonOptions,
    editResultButtonOptions,
    deleteOrderButtonOptions,
    generateCertificatePCR,
    generateCertificateAntigen,
    downloadCertificateButtonOptions,
  };
};

export default getOptionButtons;
